function datatableOptionsToQuery(options) {
  var query = {
    pageNumber: options.page,
    pageSize: options.itemsPerPage
  }
  if (options.sortBy.length > 0) {
    query.sortBy = options.sortBy[0] + ":"
    query.sortBy += options.sortDesc[0] == true ? "desc" : "asc"
  }
  return query
}

function defaultDataSort(items, index, isDesc) {
  return items
}

var mixin = {
  methods: {
    datatableOptionsToQuery,
    defaultDataSort
  }
}

export { mixin }
